module.exports = __webpack_public_path__ + "static/media/worry-time.c9098c93.png";